import React, { useEffect, useState } from "react";
import EquipmentSelector from "../EquipmentSelector/EquipmentSelector";

function CharacterEquipments({ character, editMode, handleSaveCharacter }) {
  const [equipments, setEquipments] = useState([...character.equipments]);
  const [showEquipmentSelector, setShowEquipmentSelector] = useState(false);

  useEffect(() => {
    if (!editMode) {
      setEquipments([...character.equipments]);
    }
  }, [editMode, character]);

  const handleUpdateEquipment = (index, field, value) => {
    const updatedEquipments = [...equipments];

    // Se è formato vecchio (stringa), convertilo in oggetto
    if (typeof updatedEquipments[index] === "string") {
      updatedEquipments[index] = {
        name: updatedEquipments[index],
        category: "",
        subcategory: "",
        description: "",
        cost: "",
        quantity: 1,
        notes: "",
      };
    }

    updatedEquipments[index][field] = value;
    setEquipments(updatedEquipments);
  };

  const handleSelectEquipment = (equipmentTemplate) => {
    const updatedEquipments = [...equipments];
    updatedEquipments.push(equipmentTemplate);
    setEquipments(updatedEquipments);
    setShowEquipmentSelector(false);

    // Salva automaticamente
    handleSaveCharacter({ ...character, equipments: updatedEquipments });
  };

  const handleDeleteEquipment = (index) => {
    if (
      window.confirm("Sei sicuro di voler cancellare questo equipaggiamento?")
    ) {
      const updatedEquipments = [...equipments];
      updatedEquipments.splice(index, 1);
      setEquipments(updatedEquipments);
    }
  };

  // Helper per ottenere il nome dell'equipaggiamento (supporta vecchio e nuovo formato)
  const getEquipmentName = (item) => {
    return typeof item === "string" ? item : item.name;
  };

  // Helper per ottenere la quantità
  const getEquipmentQuantity = (item) => {
    return typeof item === "string" ? 1 : item.quantity || 1;
  };

  return (
    <>
      {showEquipmentSelector && (
        <EquipmentSelector
          character={character}
          onSelect={handleSelectEquipment}
          onClose={() => setShowEquipmentSelector(false)}
        />
      )}
      <div className="character-sheetpage_equipments">
        {/* Header Row */}
        <div className="character-sheetpage_equipments_row">
          <div className="equipment_header_name">Equipaggiamento</div>
          <div className="equipment_header_quantity">Qt</div>
          <div className="equipment_header_cost">Costo</div>
          {editMode && <div className="equipment_header_delete"></div>}
        </div>

        {/* Equipment Rows */}
        {equipments.length === 0 ? (
          <div className="character-sheetpage_equipments_empty">
            Nessun equipaggiamento.{" "}
            {editMode && 'Clicca "Aggiungi Equipaggiamento" per iniziare.'}
          </div>
        ) : (
          equipments.map((item, index) => (
            <div
              key={`equipments_${index}`}
              className="character-sheetpage_equipments_row"
            >
              <div className="equipment_row_name">
                {editMode ? (
                  <input
                    type="text"
                    value={getEquipmentName(item)}
                    onChange={(e) =>
                      handleUpdateEquipment(index, "name", e.target.value)
                    }
                  />
                ) : (
                  getEquipmentName(item)
                )}
              </div>

              <div className="equipment_row_quantity">
                {editMode ? (
                  <input
                    type="number"
                    min="1"
                    value={getEquipmentQuantity(item)}
                    onChange={(e) =>
                      handleUpdateEquipment(
                        index,
                        "quantity",
                        parseInt(e.target.value) || 1,
                      )
                    }
                  />
                ) : (
                  getEquipmentQuantity(item)
                )}
              </div>

              <div className="equipment_row_cost">
                {typeof item === "object" && item.cost ? item.cost : "-"}
              </div>

              {editMode && (
                <div className="equipment_row_delete">
                  <button
                    onClick={() => handleDeleteEquipment(index)}
                    title="Elimina equipaggiamento"
                  >
                    ✕
                  </button>
                </div>
              )}
            </div>
          ))
        )}
      </div>

      {editMode && (
        <div className="character-sheetpage_equipments_submit">
          <button
            onClick={() => handleSaveCharacter({ ...character, equipments })}
          >
            Salva
          </button>
          <button onClick={() => setShowEquipmentSelector(true)}>
            Aggiungi Equipaggiamento
          </button>
        </div>
      )}
    </>
  );
}

export default CharacterEquipments;
